import { addMonitoringError } from '../domain/internalMonitoring';
import { addFailedSendBeacon } from './failedSendBeacon';
/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */
var HttpRequest = /** @class */function () {
  function HttpRequest(endpointBuilder, bytesLimit) {
    this.endpointBuilder = endpointBuilder;
    this.bytesLimit = bytesLimit;
  }
  HttpRequest.prototype.send = function (data, bytesCount, reason) {
    var url = this.endpointBuilder.build();
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < this.bytesLimit;
    if (canUseBeacon) {
      try {
        var isQueued = navigator.sendBeacon(url, data);
        if (isQueued) {
          return;
        }
        addFailedSendBeacon(this.endpointBuilder.endpointType, bytesCount, reason);
      } catch (e) {
        reportBeaconError(e);
      }
    }
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.send(data);
  };
  return HttpRequest;
}();
export { HttpRequest };
var hasReportedBeaconError = false;
function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    addMonitoringError(e);
  }
}
//# sourceMappingURL=httpRequest.js.map